import moment from 'moment'

const dateUtils = {
  defaultFormat: 'YYYY-MM-DD',
  getMonday: date => moment(date, dateUtils.defaultFormat)
    .startOf('isoweek')
    .format(dateUtils.defaultFormat),
  getSunday: date => moment(date, dateUtils.defaultFormat)
    .endOf('isoweek')
    .format(dateUtils.defaultFormat),
  getJoursOuvrees: date => dateUtils.getRange(dateUtils.getMonday(date), 6),
  getSemaine: date => dateUtils.getRange(dateUtils.getMonday(date), 7),
  getLastYearDate: date => {
    const d = moment(date, dateUtils.defaultFormat)
    return moment(`${d.year() - 1}/01/01`, 'YYYY/MM/DD')
      .add(d.week() - 1, 'week')
      .isoWeekday(d.isoWeekday())
      .format(dateUtils.defaultFormat)
  },
  toShortTime(date, liaisonWord = 'à') {
    if (isNaN(date.getTime())) return 'Date invalide'
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${liaisonWord} ${hh}h${min}`
  },

  getOnlyHoursAndMinutes(date) {
    if (!date) return 'Non définie'
    return moment(date).format('HH:mm')
  },
  formatDate(dateString) {
    if (!dateString) return 'Non définie'
  
    const date = moment(dateString)
    if (!date.isValid()) return 'Date invalide'
  
    return date.format('DD/MM/YYYY à HH:mm')
  },
  getEndSem: () => {
    if (
      moment()
        .startOf('isoweek')
        .format(dateUtils.defaultFormat)
      === moment().format(dateUtils.defaultFormat)
    ) {
      return moment().format(dateUtils.defaultFormat)
    }
    return moment()
      .subtract(1, 'day')
      .format(dateUtils.defaultFormat)
  },
  // getEndMonth: () => {
  //   if (
  //     moment()
  //       .startOf('month')
  //       .format(dateUtils.defaultFormat)
  //     === moment().format(dateUtils.defaultFormat)
  //   ) {
  //     return moment().format(dateUtils.defaultFormat)
  //   }
  //   return moment()
  //     .subtract(1, 'day')
  //     .format(dateUtils.defaultFormat)
  // },
  getStartMonth(date) {
    return moment(date, 'YYYY-MM-DD').format('YYYY-MM-01')
  },
  getEndMonth: dateRaw => moment(dateRaw, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD'),
  getEndYear: () => {
    if (
      moment()
        .startOf('year')
        .format(dateUtils.defaultFormat)
      === moment().format(dateUtils.defaultFormat)
    ) {
      return moment().format(dateUtils.defaultFormat)
    }
    return moment()
      .subtract(1, 'day')
      .format(dateUtils.defaultFormat)
  },

  getLastBuisnessDay: date => {
    let yesterday
    if (date) {
      yesterday = moment(date).subtract(1, 'day')
    } else {
      yesterday = moment().subtract(1, 'day')
    }
    if (yesterday.isoWeekday() === 7) {
      return moment()
        .subtract(2, 'day')
        .format(dateUtils.defaultFormat)
    }
    return yesterday.format(dateUtils.defaultFormat)
  },
  getWeek(wkNumber, year) {
    const weekNumber = ((wk, y) => {
      if (wk && y) {
        return moment(`${wk} ${y}`, 'ww YYYY')
      }
      return moment().startOf('isoweek')
    })(wkNumber, year)

    return dateUtils.getRange(weekNumber.format(dateUtils.defaultFormat), 7)
  },

  sortByDate(array, dateParameters) {
    return array.sort((a, b) => (
      moment(a[dateParameters], dateUtils.defaultFormat).format('X')
      - moment(b[dateParameters], dateUtils.defaultFormat).format('X')
    ))
  },
  isBefore(date1, date2) {
    return (
      moment(date2, dateUtils.defaultFormat).isSameOrBefore(
        moment(date1, dateUtils.defaultFormat)
      )
    )
  },
  isAfter(date1, date2) {
    return (
      moment(date2, dateUtils.defaultFormat).isAfter(
        moment(date1, dateUtils.defaultFormat)
      )
      && !moment(date1, dateUtils.defaultFormat).isSame(
        moment(date2, dateUtils.defaultFormat)
      )
    )
  },
  isSameMonth(date1, date2) {
    return (
      moment(date1, dateUtils.defaultFormat).format('MM')
      === moment(date2, dateUtils.defaultFormat).format('MM')
    )
  },
  getRange(startDate = moment().format('YYYY-MM-DD'), nbDays = 0) {
    const momentedStartDate = moment(startDate, dateUtils.defaultFormat)
    const nextDays = [...Array(nbDays - 1).keys()].map(() => momentedStartDate.add(1, 'days').format(dateUtils.defaultFormat))
    return [].concat(startDate, nextDays)
  },
  getMonthDays(date) {
    const momentDate = moment(date, dateUtils.defaultFormat)
    const startDate = momentDate
      .startOf('month')
      .format(dateUtils.defaultFormat)
    const nbDays = momentDate.daysInMonth()
    return dateUtils.getRange(startDate, nbDays)
  },
  getNameDayOfWeek: () => {
    const days = dateUtils.getSemaine(moment().format(dateUtils.defaultFormat))
    return days.map(NameDay => moment(NameDay).format('dddd'))
  },
  paques: Y => {
    const a = Y % 19
    const b = Math.floor(Y / 100)
    const c = Y % 100
    const d = Math.floor(b / 4)
    const e = b % 4
    const f = Math.floor((b + 8) / 25)
    const g = Math.floor((b - f + 1) / 3)
    const h = (19 * a + b - d - g + 15) % 30
    const i = Math.floor(c / 4)
    const k = c % 4
    const l = (32 + 2 * e + 2 * i - h - k) % 7
    const m = Math.floor((a + 11 * h + 22 * l) / 451)
    const n0 = (h + l + 7 * m + 114)
    const n = Math.floor(n0 / 31) - 1
    const p = n0 % 31 + 1
    const date = new Date(Y, n, p)
    return moment(date)
  },
  isJourFerie: date => {
    const year = moment(date, 'YYYY-MM-DD').format('YYYY')
    const paquesValue = moment(dateUtils.paques(year)).format('YYYY-MM-DD')
    const listeFeries = [
      {day: 'Jour de l\'an', value: moment(`1-1-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Fête du travail', value: moment(`1-5-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Victoire des alliés', value: moment(`8-5-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Fête Nationale', value: moment(`14-7-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Assomption', value: moment(`15-8-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Toussaint', value: moment(`1-11-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Armistice', value: moment(`11-11-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Noël', value: moment(`25-12-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')},
      {day: 'Lundi de Pâques', value: moment(paquesValue).add(1, 'days').format('YYYY-MM-DD')},
      {day: 'Ascension', value: moment(paquesValue).add(39, 'days').format('YYYY-MM-DD')},
      {day: 'Pentecôte', value: moment(paquesValue).add(50, 'days').format('YYYY-MM-DD')}
    ]
    return listeFeries.filter(ferie => ferie.value === moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')).length > 0
  }
}

export default dateUtils
